import {initializeApp} from "firebase/app";
import {getFirestore} from "firebase/firestore";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBjuDz4q1F2_QsUz8Wn2trJD7eEJt2BHaw",
  authDomain: "woomoo-works.firebaseapp.com",
  projectId: "woomoo-works",
  storageBucket: "woomoo-works.firebasestorage.app",
  messagingSenderId: "550201778713",
  appId: "1:550201778713:web:6030f9aa949f3b32518088",
  measurementId: "G-8JNXKQVMJQ"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
export { auth, db, GoogleAuthProvider, signInWithPopup, signOut };
